import React from "react";
import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import BillPreview from "./components/BillPreview";
import { Grid } from "@material-ui/core";
import { goLogin, getPermission, getStampTime } from "./js/main";
import PaymentIcon from "@material-ui/icons/Payment";
import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";

const current_path = Conf.frontendURL + "report";
const page_title = "Cash Payment";

export default class Tranfer extends React.Component {
  state = {
    invoice: {},
    cookie: null,
    is_load: false,
    paid: false,
    payback: 0,
  };

  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      console.log(auth);
      var invoice = await this.getInvoice();
      console.log(invoice);
      var paid = false;
      if (invoice.canceled.status === true || invoice.bills.length > 0) {
        paid = true;
      }
      if (auth === false) goLogin(current_path);
      else
        this.setState(
          {
            profile: auth.profile,
            cookie: cookie,
            invoice: invoice,
            paid: paid,
          },
          async () => {
            var i = invoice.bills.length - 1;
            var otp = await this.getOTP(invoice.bills[i]);
            this.setState({ otp });
          }
        );
    } else goLogin(current_path);
  }
  getInvoice() {
    return new Promise((resolve) => {
      var id = this.props.match.params.id;
      axios.get(Conf.backendURL + "invoice/" + id).then((res) => {
        resolve(res.data);
      });
    });
  }
  showFieldValue(id) {
    var { invoice } = this.state;
    if (invoice[id] && invoice[id] !== "") return invoice[id];
    else return "-";
  }
  /*
   */
  confirmPay() {
    //https://stackoverflow.com/questions/17415579/how-to-iso-8601-format-a-date-with-timezone-offset-in-javascript
    // console.log("2021-01-05T12:53:03.000+07:00");
    this.setState({ is_load: true }, async () => {
      // var dt = new Date().toISOString();
      // dt = dt.substr(0, dt.length - 1);

      var dt = await getStampTime();
      dt = dt.iso_date + "T" + dt.host_time;
      var transactionDateandTime = dt + "+07:00";

      var { invoice, profile } = this.state;
      var send = {
        invoice_id: invoice._id,
        payerName: invoice.debtor_name,
        amount: invoice.amount,
        transactionDateandTime: transactionDateandTime,
        transactionType: "Pay by Cash",
        description: "ชำระผ่านระบบ CMUL Digital Payment",
        payer: {
          name: invoice.debtor_name,
          idx: invoice.debtor_idx,
          vat: invoice.debtor_vat,
          addr: invoice.debtor_address,
          email: invoice.debtor_email,
        },
        operator: {
          name: profile.PrenameTha + profile.NameTha + " " + profile.SurNameTha,
          usn: profile.Email,
        },
      };
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .post(Conf.digitalpayBackend + "paid/cash", send, {
          headers: { Authorization: cookie.token },
        })
        .then(async (res) => {
          let otp = await this.getOTP(res.data.bill_id);
          console.log(res.data);
          this.setState({ is_load: false, paid: true, otp });
        });
    });
  }
  changeForm(e) {
    var amount = this.state.invoice.amount;
    var receive_amount =
      parseFloat(document.getElementById("receive_amount").value) || 0;
    if (receive_amount === 0) receive_amount = "";
    else receive_amount -= amount;
    this.setState({ payback: receive_amount });
  }

  getOTP(bill_id) {
    return new Promise(async (resolve) => {
      // var bill_id = this.props.match.params.id;
      var bill = await this.getBill(bill_id);
      console.log(bill.bill_id);
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .post(
          Conf.digitalpayBackend + "otp",
          { type: "bill_preview", payload: { bill_id: bill.bill_id } },
          {
            headers: { Authorization: cookie.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        });
    });
  }
  getBill(id) {
    return new Promise((resolve) => {
      axios
        .get(Conf.digitalpayBackend + "bill/" + id, {
          headers: { Authorization: this.state.cookie.token },
        })
        .then((res) => {
          resolve(res.data);
        });
    });
  }
  render() {
    const { invoice, profile, is_load, paid, payback, otp } = this.state;
    const styles = {
      fieldName: {
        fontWeight: 500,
        fontSize: "0.8rem",
      },
      fieldValue: {
        fontSize: "1.5rem",
        paddingBottom: "20px",
      },
    };
    return (
      <>
        {invoice.invoice_id && (
          <div>
            <Navbar />
            <main className="content">
              <h1 className="pageTitle">
                <div
                  style={{
                    float: "left",
                    padding: "5px",
                    marginRight: "15px",
                  }}
                >
                  <PaymentIcon style={{ fontSize: "2rem" }} />
                </div>
                <div style={{ float: "none" }}>{page_title}</div>
              </h1>
              <br />
              {paid === false ? (
                <>
                  <Grid container>
                    <Grid item xs={6} style={{ paddingLeft: "30px" }}>
                      <div style={styles.fieldName}>
                        ชื่อผู้ชำระเงิน (Payer Name)
                      </div>
                      <div style={styles.fieldValue}>{invoice.debtor_name}</div>
                      <div style={styles.fieldName}>
                        หมายเลขบัตรประชาชน/หมายเลขผู้เสียภาษี (ID Card/Tax
                        Number)
                      </div>
                      <div style={styles.fieldValue}>
                        {this.showFieldValue("debtor_idx")}
                      </div>
                      <div style={styles.fieldName}>
                        อีเมลสำหรับจัดส่งใบเสร็จ (e-Mail)
                      </div>
                      <div style={styles.fieldValue}>
                        {this.showFieldValue("debtor_email")}
                      </div>
                      <div style={styles.fieldName}>ที่อยู่ (Address)</div>
                      <div
                        style={{
                          ...{ fontSize: "1.2rem" },
                          ...styles.fieldValue,
                        }}
                      >
                        {this.showFieldValue("debtor_address")}
                      </div>
                      <div style={styles.fieldName}>จำนวนเงิน</div>
                      <div style={styles.fieldValue}>
                        {invoice.amount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </div>
                      <div style={styles.fieldName}>ผู้ดำเนินการ</div>
                      <div style={styles.fieldValue}>
                        {profile.PrenameTha}
                        {profile.NameTha} {profile.SurNameTha}
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <TableContainer>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                component="th"
                                scope="row"
                                style={styles.fieldValue}
                              >
                                จำนวนเงิน
                              </TableCell>
                              <TableCell
                                align="center"
                                style={styles.fieldValue}
                              >
                                {invoice.amount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                })}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                component="th"
                                scope="row"
                                style={styles.fieldValue}
                              >
                                รับเงิน
                              </TableCell>
                              <TableCell>
                                <TextField
                                  fullWidth
                                  onChange={(e) => this.changeForm(e)}
                                  id="receive_amount"
                                  variant="outlined"
                                  type="number"
                                  inputProps={{
                                    style: {
                                      textAlign: "center",
                                      fontSize: "1.5rem",
                                    },
                                  }}
                                  // size="large"
                                />
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                component="th"
                                scope="row"
                                style={styles.fieldValue}
                              >
                                เงินทอน
                              </TableCell>
                              <TableCell
                                align="center"
                                style={styles.fieldValue}
                              >
                                {payback}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                  <div style={{ marginTop: "20px", textAlign: "right" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={() => this.confirmPay()}
                      disabled={is_load}
                    >
                      Confirm Payment
                    </Button>
                  </div>
                </>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <h1>สำนักหอสมุดได้รับเงินแล้ว</h1>
                  {invoice &&
                    invoice.debtor_email &&
                    invoice.debtor_email !== "" && (
                      <div style={{ fontSize: "1.2rem" }}>
                        ใบเสร็จรับเงินจะถูกส่งไปยังอีเมล
                        <br />
                        {invoice.debtor_email}
                      </div>
                    )}
                  <br />
                  {otp && <BillPreview otp={otp} />}
                </div>
              )}
            </main>
          </div>
        )}
      </>
    );
  }
}
